var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25732 10.9992C2.25732 7.16329 5.01441 3.74113 8.76879 2.93872C10.6447 2.53783 12.6395 2.80789 14.3369 3.70228C15.9705 4.56307 17.2908 5.97427 18.039 7.66267C18.8175 9.4189 18.9532 11.4351 18.4223 13.281C17.9103 15.0618 16.7866 16.6408 15.2782 17.7158C12.1246 19.9634 7.69485 19.6629 4.86909 17.0186C3.21303 15.4688 2.25732 13.2676 2.25732 10.9992ZM10.9402 14.9532L13.2414 12.7062C13.8241 12.1374 12.9413 11.2381 12.3613 11.8047L11.2002 12.9385L11.2002 7.56544C11.2002 7.18387 10.8816 6.86551 10.5002 6.86551C10.1189 6.86551 9.80031 7.18408 9.80031 7.56544L9.80031 12.9116L8.64426 11.7554C8.0697 11.1808 7.17867 12.0716 7.75323 12.6462L10.0548 14.948C10.2986 15.192 10.6934 15.1943 10.9402 14.9532Z",
    fill: "#EB454E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedDown);
export default ForwardRef;